import Box from "@mui/material/Box";

import { MdWarning } from "react-icons/md";
import FdButton from "../../../components/UIComponents/Button/FdButton";
import FdTypography from "../../../components/UIComponents/Typography/FdTypography";
import { theme } from "../../../theme";


export interface IProps {
  onConfirm: Function;
}

function EmptyFileWarning({ onConfirm }: IProps) {
  return (
    <Box>
      <MdWarning size="45" color={theme.palette.primary.main} />
      <Box marginBottom="15px" marginTop="15px">
        <FdTypography label="CSV Upload Warning!" variant="h2" component="h2" />
      </Box>
      <Box marginBottom="20px">
        The uploaded CSV file appears to be empty. <br />
        Please, check your file!
      </Box>
      <FdButton
        size="medium"
        onClick={() => {
          onConfirm();
        }}
        ButtonName="Ok"
      />
    </Box>
  );
}

export default EmptyFileWarning;
